<template>
  <div class="training_table">
    <div class="waitingcom_title">
      <el-form
        label-width="80px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="操作名称：" prop="operationName">
          <el-input
            v-model.trim="formLabelAlign.operationName"
            placeholder="请输入操作名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="操作状态：" prop="operationModel">
          <el-select
            v-model.trim="formLabelAlign.operationModel"
            label="全部"
            placeholder="请选择操作状态"
            @change="searchChang"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in modelArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考核时间：" prop="examTime">
          <div class="block">
            <el-date-picker
              @change="searchChang"
              v-model="examTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          :loading="sundflag"
          @click="searchData()"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click.prevent.stop="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <div class="flex_">
      <!-- 按钮 -->
      <div class="oper_box">
        <el-button @click="toAdd(0)">
          <img src="@/assets/button_imgs/tianjia.png" alt="" />
          新增操作考核
        </el-button>
        <el-button id="addButtonJm" @click="deleteClick(0)">
          <img src="@/assets/button_imgs/shangchuang.png" alt="" />
          批量删除
        </el-button>
      </div>
      <!-- 文档 -->
      <div class="word_view" @click="DownloadClick">
        <p>功能使用说明</p>
        <i class="el-icon-question"></i>
      </div>
    </div>

    <!-- 表格 -->
    <div class="hos_mian" v-loading="loading">
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :cell-class-name="stateColor"
        @selection-change="handleSelectionChange"
        @row-click="StepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#EEEEEE',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column
          type="selection"
          width="50px"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + (pageIndexs - 1) * eachPageNums + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="Title" label="操作名称" width="180">
          <template slot-scope="scope">
            <!-- <i
              style="font-size: 18px;color:#64b5ff ;"
              class="isselectico iconfont icon-ico"
              @click.stop="openqrwindows(scope.row)"
            ></i> -->
            {{ scope.row.Title }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="360">
          <template slot-scope="scope">
            <div class="operation_">
              <el-button
                type="text"
                size="small"
                :disabled="
                  scope.row.IsScore == 1 && scope.row.examStatus == '考核结束'
                "
                @click.stop="toAdd(1, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="toAdd(2, scope.row, scope.$index)"
                >补考</el-button
              >
              <el-button
                type="text"
                size="small"
                :disabled="scope.row.examStatus != '考核中'"
                @click.stop="downStateClick(scope.row, scope.$index)"
                >{{
                  scope.row.Status1 == "考核开启" ? "结束考核" : "开启考核"
                }}</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="deleteClick(1, scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="foot_box">
      <div class="foot_pagetions">
        <p>
          <!-- 共有{{ total }}条记录，当前第{{ pageIndex + 1 }}/{{ pagesun }}页 -->
        </p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndexs"
          :page-size="eachPageNums"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹窗 -->
    <QrPopup
      ref="popup"
      :statePopupstatus="statePopupstatus"
      :title="'考核二维码'"
    />
    <!-- 删除 -->
    <Delete
      ref="delete"
      :statePopupstatus="statePopupstatus"
      :deleteType="deleteType"
      :userName="userName"
      :deleteNum="deleteNum"
      :deleteDetermine="deleteDetermine"
      :editorfun="editorfun"
    />
    <ComPopup :prompt="prompt" ref="ComPopup" :fun2="downState" />
  </div>
</template>

<script>
import { hybrid } from "@/mixin/mixin";
// import Popup from "../../../training/release/components/Popup.vue";
import QrPopup from "@/components/progress/QrPopup.vue";
import { operation, modelArr } from "@/state/operation";
import Delete from "@/components/progress/Delete.vue";
import assessApi from "@/api/assessment";
import ComPopup from "@/components/ComPopup.vue";
import html2canvas from "html2canvas";
import loginvuex from "@/store/index";

export default {
  data() {
    return {
      formLabelAlign: {
        operationName: "", // 操作名称
        operationModel: "", // 操作状态
        beginTime: "", // 起始时间
        endTime: "", // 结束时间
      },
      getDataCondition: {
        operationName: "", // 培训名称
      },
      examTime: "", // 时间
      modelArr: [],
      formColumns: [], // 表头
      getData: [{ name: "测试" }], // 数据
      multipleSelection: [], // 表单选中
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      loading: true,
      qrdialogVisible: false, // 二维码弹窗
      statePopupstatus: {}, // 当前行的信息
      deleteType: 0, // 删除打开弹窗
      userName: "", // 单个删除的名字
      deleteNum: "", // 批量删除的个数
      pageIndexs: 1, // 起始页
      eachPageNums: 10, // mixin定义的获取渲染分页序号有误
      examineID: "", // 当前行ID
      sundflag: false, // 防抖
      prompt: {
        title: "温馨提示",
        info: "当前操作将开启考核是否继续？",
        type: "",
      }, // 提示弹窗
      row: {},
    };
  },
  components: {
    QrPopup,
    Delete,
    ComPopup,
  },
  mixins: [hybrid], // 引入共用方法
  methods: {
    // chang查询
    searchChang() {
      this.pageIndexs = 1;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.loading = true;
      this.getDatalist();
    },
    // 搜索
    searchData() {
      if (this.formLabelAlign.operationName) {
        this.getDataCondition.operationName = this.formLabelAlign.operationName;
      } else {
        this.getDataCondition.operationName = "";
      }
      this.pageIndexs = 1;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.loading = true;
      this.getDatalist();
    },
    // 重置
    resetForm() {
      this.examTime = "";
      this.pageIndexs = 1;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.resetFun(this.formLabelAlign, this.getDataCondition);
      this.loading = true;
      // this.getDatalist();
    },
    // 二维码弹窗
    openqrwindows(testid) {
      //打开二维码传入试卷ID
      // this.qrdialogVisible = true;
      this.$refs.popup.dialogVisibleObj.qrPopup = true; // 唤起弹窗
      this.statePopupstatus = testid;
      let parmars = {
        value: "https://stsqapit.tibosi.com/sharewebview",
        examid: testid.ID,
        paperid: testid.PaperID,
      };
      this.$refs.popup.config.value = `${process.env.VUE_APP_QR}/checkDetail?examineID=${testid.ID}`;
      console.log(this.$refs.popup.config.value, "------------->>");
      // this.$refs.popup.config.value = JSON.stringify(parmars);
      //生成图片
      setTimeout(() => {
        const canvasIns = html2canvas(this.$refs.popup.$refs.codeDownLoad, {
          backgroundColor: "#fff",
          useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
          logging: true,
          scale: 2,
        }).then(
          (canvas) => {
            const url = canvas.toDataURL("image/png", 1.0);
            this.$refs.popup.$refs.saveImage.setAttribute("src", url);
          },
          (err) => {}
        );
      }, 500);
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.examStatus === "考核中" && columnIndex === 4) {
        return "blue";
      } else if (row.examStatus === "考核结束" && columnIndex === 4) {
        return "red";
      } else if (row.examStatus === "待考核" && columnIndex === 4) {
        return "gray";
      } else if (row.Status1 === "考场关闭" && columnIndex === 5) {
        return "red";
      } else if (row.Status1 === "考场开启" && columnIndex === 5) {
        return "gray";
      }
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    getRowKeyOfTarget(row) {
      return row.ID;
    },
    // 获取表格
    async getDatalist() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formLabelAlign.beginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.endTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      this.sundflag = true;
      let parameter = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        title: this.getDataCondition.operationName, // 名称
        c_status: this.formLabelAlign.operationModel, // 状态(0待考核 1考核中 2考核结束 3考核关闭)
        beginTime: this.formLabelAlign.beginTime, // 开始时间
        endTime: this.formLabelAlign.endTime, // 结束时间
        pageIndex: this.pageIndexs, //当前页
        pageSize: this.eachPageNums, // 一页多少条
      };
      const { data } = await assessApi.getExaminelist(parameter);
      if (data.Status == 200) {
        this.getData = data.Data.list;
        this.total = data.Data.dataCount;
        setTimeout(() => {
          this.loading = false;
          this.sundflag = false;
        }, 500);
        this.operationData();
      } else {
        this.sundflag = false;
        this.$message.error(data.Data);
      }
    },
    // 操作数据
    operationData() {
      let newDate = this.$moment().valueOf(); // 获取当前时间
      this.getData = this.getData.map((item) => {
        this.$set(
          item,
          "time",
          this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
            "-" +
            this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm")
        );
        this.$set(
          item,
          "CreateTime1",
          this.$moment(item.CreateTime).format("YYYY/MM/DD HH:mm")
        );

        this.$set(item, "TotalUser1", item.TotalUser - item.ApplyUser); // 未考人数
        this.$set(item, "Status1", item.Status == 3 ? "考核关闭" : "考核开启"); // 3为关闭其他都是开启
        if (newDate < this.$moment(item.BeginTime).valueOf()) {
          // 当前时间小于起始时间
          item.examStatus = "待考核";
        } else if (this.$moment(item.EndTime).valueOf() < newDate) {
          // 当前时间大于结束时间
          item.examStatus = "考核结束";
        } else {
          item.examStatus = "考核中";
        }
        // 考核结束 状态变成考核关闭
        if (item.examStatus == "考核结束") {
          item.Status1 = "考核关闭";
        }
        return item;
      });
    },
    // 删除
    deleteClick(type, row, index) {
      this.deleteType = type; // 删除状态
      this.statePopupstatus = row;
      if (this.multipleSelection.length == 0 && type == 0) {
        // 未勾选批量考生
        this.deleteType = "null";
      } else if (type == 1) {
        // 单个删除
        this.userName = row.Title;
      } else if (type == 0) {
        // 批量删除
        // this.deleteNum = this.multipleSelection.length;
      }
      this.$refs.delete.dialogVisibleObj.Delete = true;
    },
    // 删除确定执行
    async deleteDetermine() {
      let obj = {
        examineIDArray: "",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      this.$refs.delete.sundflag = true;
      if (this.deleteType == "null") {
        // 未选择
        this.$refs.delete.sundflag = false;
        this.$refs.delete.dialogVisibleObj.Delete = false;
        return;
      }
      if (this.deleteType == 0) {
        obj.examineIDArray = `[${this.multipleSelectionIds}]`;
      } else if (this.deleteType == 1) {
        obj.examineIDArray = `[${this.statePopupstatus.ID}]`;
      }
      const { data } = await assessApi.deleteOperation(obj);
      if (data.Status == 200) {
        this.$message({
          message: `恭喜你，操作${
            this.deleteType == 1 ? this.statePopupstatus.Title : ""
          }删除成功`,
          type: "success",
        });
        setTimeout(() => {
          this.$refs.delete.sundflag = false;
        }, 500);
        this.$refs.tabledata.clearSelection(); // 清除勾选状态
        this.getDatalist();
      } else {
        this.$refs.delete.sundflag = false;
        this.$message.error(data.Msg);
      }
      this.$refs.delete.dialogVisibleObj.Delete = false;
    },
    // 开启关闭考核
    async downState() {
      let obj = {
        examineID: this.row.ID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      this.$refs.ComPopup.sundflag = true;
      const { data } = await assessApi.openDownStatus(obj);
      if (data.Status == 200) {
        this.$message({
          message: `恭喜你，操作名称${this.row.Title}考场状态已修改`,
          type: "success",
        });
        setTimeout(() => {
          this.$refs.ComPopup.sundflag = false;
        }, 500);
        this.getDatalist();
      } else {
        this.$refs.ComPopup.sundflag = false;
        this.$message.error(data.Msg);
      }
    },
    // 执行
    downStateClick(row, index) {
      this.row = row;
      // scope.row.Status1 == "考核开启" ? "结束考核" : "开启考核"
      if (row.Status1 == "考核开启") {
        this.prompt.info = "当前考场状态为开启，此操作将结束考核是否继续？";
      } else {
        this.prompt.info = "当前考场状态为关闭，此操作将开启考核是否继续？";
      }
      this.$refs.ComPopup.dialogVisibleObj.export = true;
    },
    // 获取选中的数据
    handleSelectionChange(val) {
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      this.multipleSelection = val; // 批量删除多选状态
      val.forEach((v) => {
        this.multipleSelectionIds.push(v.ID);
      });
      this.multipleSelectionCount = this.multipleSelection.length;
      // console.log(this.multipleSelectionIds, "<<=====multipleSelectionIds");
    },
    // 添加
    toAdd(type, row) {
      // 0 新增  1 编辑  2 复制
      // 考核中只能编辑时间，待考核可以编辑，考核结束且已评分情况不能编辑
      if (type == 1 && row.examStatus == "考核中") {
        this.examineID = row.ID;
        this.$refs.delete.dialogVisibleObj.editor = true;
        this.$refs.delete.time[0] = this.$moment(row.BeginTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.$refs.delete.time[1] = this.$moment(row.EndTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        this.$router.push({
          path: "/operationCheck/releaseCheck/addCheck", //跳转的路径
          query: {
            type: type,
            ID: type == 0 ? "" : row.ID,
          },
        });
      }
    },
    // 编辑时间
    async editorfun() {
      let obj = {
        examineID: this.examineID,
        beginTime: this.$refs.delete.time[0],
        endTime: this.$refs.delete.time[1],
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      this.$refs.delete.sundflag = true;
      const { data } = await assessApi.deitOperation(obj);
      if (data.Status == 200) {
        this.$message({
          message: `恭喜你，编辑成功`,
          type: "success",
        });
        this.$refs.delete.dialogVisibleObj.editor = false;
        setTimeout(() => {
          this.$refs.delete.sundflag = false;
        }, 500);
        this.getDatalist();
      } else {
        this.$refs.delete.sundflag = false;
        this.$message.error(data.Msg);
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.eachPageNums = val;
      this.getDatalist();
    },
    handleCurrentChange(val) {
      this.pageIndexs = val;
      console.log(`当前页: ${this.pageIndexs}`);
      this.loading = true;
      this.getDatalist();
    },
    // 下载文档
    DownloadClick() {
      this.$confirm("此操作将下载功能使用说明, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.$message({
          //   type: "success",
          //   message: "删除成功!",
          // });
          let a = document.createElement("a");
          a.href = `${process.env.BASE_URL}lczn.docx`;
          a.setAttribute("download", "临床技能考核手册" + ".docx");
          a.download = "临床技能考核手册.docx";
          a.click();
          console.log("???");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
  created() {
    this.formColumns = operation;
    this.modelArr = modelArr;
    this.getDatalist();
  },
};
</script>

<style lang="scss" scoped>
.training_table {
  height: 100%;
  width: 100%;
  min-height: 740px;
  background: #fff;
}
.waitingcom_title {
  height: 90px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item__content {
    margin-left: 115px !important;
  }
  .el-form {
    display: flex;
  }
}
.hos_table {
  min-height: 560px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
}
.sonbtn {
  border: 1px solid #d9d9d9 !important;
  color: #999999;
}
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    letter-spacing: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #000000;
    &:nth-child(1) {
      width: 140px;
    }
    span {
      display: flex;
      align-items: center;
    }
    span > img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
// 表格
.hos_mian {
  padding: 0px 24px;
  margin-top: 24px;
  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(11) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
  .operation_box {
    ::v-deep .el-button--text {
      font-size: 16px;
      font-weight: 400;
      // color: #0084ea;
      > span {
        padding-right: 8px;
        border-right: 1px solid #0084ea;
      }
      &:nth-child(3) {
        color: #ff4747;
        > span {
          border-right: none !important;
        }
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #999999 !important;
}
::v-deep .el-table .blue .cell {
  color: #0084ea !important;
}

.operation_ {
  ::v-deep .el-button--text {
    font-size: 16px;
    font-weight: 400;
    // color: #0084ea;
    > span {
      padding-right: 8px;
      border-right: 1px solid #0084ea;
    }
    // margin-right: 20px;
    &:nth-child(4) {
      color: #ff4747;
      > span {
        border-right: none !important;
      }
    }
  }
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #0084ea;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #0084ea;
        border: none;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}
.flex_ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .word_view {
    border: 1px solid #d9d9d9;
    padding: 8px;
    display: flex;
    margin-right: 42px;
    align-items: center;
    i {
      margin-left: 12px;
    }
  }
}
</style>
